import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BYPASS_ERROR_HANDLING, BypassMode } from './error-bypass';
import { parseBackendErrorResponse } from './backend.errors';

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return next(req).pipe(catchError((error: HttpErrorResponse) => httpErrorHandler(router, logger, req, error)));
}

function httpErrorHandler(
  router: Router,
  logger: NGXLogger,
  request: HttpRequest<unknown>,
  response: HttpErrorResponse,
) {
  logger.error(`an error occurred: server responded with ${response.status}`);
  const backendErrorType = parseBackendErrorResponse(response.error, response.status);

  if (!isBypassed(request, response)) {
    router.navigate(['error']);
  }

  return throwError(() => new Error(backendErrorType));
}

function isBypassed(request: HttpRequest<unknown>, response: HttpErrorResponse): boolean {
  const mode = request.context.get(BYPASS_ERROR_HANDLING);
  const status = response.status;
  const isClientError = status >= 400 && status < 500;
  const isServerError = status >= 500 && status < 600;
  if (mode === BypassMode.CLIENT_AND_SERVER_ERRORS) return isClientError || isServerError;
  if (mode === BypassMode.CLIENT_ERRORS) return isClientError;
  return false;
}
